import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "my"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "sub-title van-ellipsis"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
    fit: "cover",
    width: "60",
    height: "60",
    round: "",
    src: _ctx.userInfo.photoPath,
    onClick: _ctx.preview
  }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.userInfo.name), 1), _cache[0] || (_cache[0] = _createElementVNode("p", null, "欢迎您回来！", -1))]), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "mt8"
  }, {
    default: _withCtx(() => {
      var _ctx$userInfo$amount;
      return [_createVNode(_component_van_cell, {
        title: "学号",
        value: _ctx.userInfo.jobNum
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "所属班级",
        value: _ctx.userInfo.deptName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "余额",
        value: ((_ctx$userInfo$amount = _ctx.userInfo.amount) !== null && _ctx$userInfo$amount !== void 0 ? _ctx$userInfo$amount : 0) + '元'
      }, null, 8, ["value"])];
    }),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "mt8"
  }, {
    default: _withCtx(() => {
      var _ctx$userInfo$amount2;
      return [_createVNode(_component_van_cell, {
        title: "在线充值",
        "is-link": "",
        to: '/consume/recharge?amount=' + ((_ctx$userInfo$amount2 = _ctx.userInfo.amount) !== null && _ctx$userInfo$amount2 !== void 0 ? _ctx$userInfo$amount2 : 0)
      }, null, 8, ["to"]), _createVNode(_component_van_cell, {
        title: "消费限制",
        "is-link": "",
        to: "/consume/limit"
      }), _createVNode(_component_van_cell, {
        title: "交易记录",
        "is-link": "",
        to: "/consume/log"
      })];
    }),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "mt8"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: "入校预约",
      "is-link": "",
      to: "/visitor"
    })]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "mt8"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: "请假单管理",
      "is-link": "",
      to: "/leave"
    })]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    inset: "",
    class: "mt8"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: "绑定其他账号",
      "is-link": "",
      to: "/bind/switch"
    })]),
    _: 1
  })]);
}